import { getLocale } from "../../i18n";
import { useTranslation } from "react-i18next";
import { translate as tr } from "../../i18n";
import React, { useState,useEffect,useRef, lazy, Suspense } from "react";
import SideBar from "../common/sidebar";
import "../../assets/css/project-chart.css";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import ColorPicker from "../common/ColorPicker";
import { setAlert } from "../../actions/alert";
import Alert from "../common/Alert";
import {Modal } from "react-bootstrap";
import "../../utils/chartjs";
import { Doughnut } from "react-chartjs-2";
import { Link, useNavigate, useParams, NavLink } from "react-router-dom";
import Loader from "../common/loader";
import { alterTimeFormat, alterDisplayTime } from "../common/displayTime";
import moment from "moment-timezone";
import ProjectBillingRateField from "../common/ProjectBillingRateField";

const Dashboard = lazy(()=> import("./dashboard"));
const ProjectReport = lazy(() => import('./reports'));

const ProjectDashboardSkeleton = () => (
  <div className="content-wrap" id="wrapper" aria-hidden="true">
    <div className="main">
      <div className="pd-page">
        {/*
          Mirror the real dashboard structure so refreshes feel like the page is
          loading, not like content vanished.
        */}
        <div className="pd-top-row" style={{ marginBottom: 16 }}>
          <div className="pd-health-badge" style={{ background: "#eef5ef", border: "1px solid #dde7de", minWidth: 340 }}>
            <span className="pd-health-dot sk-bar" style={{ width: 10, height: 10, borderRadius: 999 }} />
            <span className="pd-health-label sk-bar" style={{ width: 70, height: 12, borderRadius: 999 }} />
            <span className="pd-health-sub sk-bar" style={{ width: 210, height: 12, borderRadius: 999 }} />
          </div>
          <div className="proj-status-tabs">
            <span className="sk-bar" style={{ width: 74, height: 30, borderRadius: 20 }} />
            <span className="sk-bar" style={{ width: 74, height: 30, borderRadius: 20 }} />
            <span className="sk-bar" style={{ width: 74, height: 30, borderRadius: 20 }} />
          </div>
        </div>

        <div className="pd-kpi-row">
          {Array.from({ length: 4 }).map((_, index) => (
            <div className="pd-kpi-card" key={`project-dashboard-skeleton-kpi-${index}`}>
              <span className="pd-kpi-icon sk-bar" style={{ width: 40, height: 40, borderRadius: 12 }} />
              <div className="pt-kpi-copy" style={{ gap: 6 }}>
                <span className="sk-bar" style={{ width: 92, height: 10, borderRadius: 999 }} />
                <span className="sk-bar" style={{ width: 118, height: 24, borderRadius: 8 }} />
                <span className="sk-bar" style={{ width: 104, height: 10, borderRadius: 999 }} />
              </div>
            </div>
          ))}
        </div>

        <div className="proj-chart-card pd-full-card" style={{ minHeight: 260 }}>
          <div className="proj-chart-header">
            <div>
              <span className="sk-bar" style={{ width: 160, height: 16, borderRadius: 999, display: "block", marginBottom: 8 }} />
              <span className="sk-bar" style={{ width: 240, height: 12, borderRadius: 999, display: "block" }} />
            </div>
            <span className="sk-bar" style={{ width: 112, height: 28, borderRadius: 999 }} />
          </div>
          <div style={{ padding: 24, display: "grid", gap: 16 }}>
            <span className="sk-bar" style={{ width: "100%", height: 12, borderRadius: 999 }} />
            <span className="sk-bar" style={{ width: "100%", height: 12, borderRadius: 999 }} />
            <span className="sk-bar" style={{ width: "72%", height: 12, borderRadius: 999 }} />
            <div className="pd-billable-stats" style={{ marginTop: 12 }}>
              {Array.from({ length: 4 }).map((_, index) => (
                <div className="pd-billable-stat pd-billable-stat--skeleton" key={`project-dashboard-skeleton-stat-${index}`}>
                  <span className="pd-billable-skeleton-label sk-bar" />
                  <span className="pd-billable-skeleton-value sk-bar" />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="pd-charts-row">
          {Array.from({ length: 2 }).map((_, index) => (
            <div className="proj-chart-card pd-half-card" key={`project-dashboard-skeleton-chart-${index}`}>
              <div className="proj-chart-header">
                <div>
                  <span className="sk-bar" style={{ width: 128, height: 16, borderRadius: 999, display: "block", marginBottom: 8 }} />
                  <span className="sk-bar" style={{ width: 176, height: 12, borderRadius: 999, display: "block" }} />
                </div>
              </div>
              <div style={{ padding: 24, display: "grid", gap: 14 }}>
                <div style={{ display: "grid", gridTemplateColumns: "140px 1fr", gap: 16, alignItems: "center" }}>
                  <span className="sk-bar" style={{ width: 136, height: 136, borderRadius: "50%", margin: "0 auto" }} />
                  <div style={{ display: "grid", gap: 10 }}>
                    {Array.from({ length: 4 }).map((_, legendIndex) => (
                      <div key={`project-dashboard-skeleton-legend-${index}-${legendIndex}`} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <span className="sk-bar" style={{ width: 10, height: 10, borderRadius: 999 }} />
                        <span className="sk-bar" style={{ width: legendIndex === 0 ? "72%" : legendIndex === 1 ? "64%" : legendIndex === 2 ? "58%" : "46%", height: 10, borderRadius: 999 }} />
                      </div>
                    ))}
                  </div>
                </div>
                <div style={{ display: "grid", gap: 8 }}>
                  <span className="sk-bar" style={{ width: "100%", height: 12, borderRadius: 999 }} />
                  <span className="sk-bar" style={{ width: "86%", height: 12, borderRadius: 999 }} />
                  <span className="sk-bar" style={{ width: "68%", height: 12, borderRadius: 999 }} />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="proj-chart-card pd-full-card" style={{ marginBottom: 40 }}>
          <div className="proj-chart-header">
            <div>
              <span className="sk-bar" style={{ width: 148, height: 16, borderRadius: 999, display: "block", marginBottom: 8 }} />
              <span className="sk-bar" style={{ width: 220, height: 12, borderRadius: 999, display: "block" }} />
            </div>
          </div>
          <div style={{ padding: 24, display: "grid", gap: 12 }}>
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={`project-dashboard-skeleton-row-${index}`} style={{ display: "grid", gridTemplateColumns: "28px 1fr 88px", gap: 12, alignItems: "center" }}>
                <span className="sk-bar" style={{ width: 28, height: 28, borderRadius: 999 }} />
                <span className="sk-bar" style={{ width: index === 0 ? "72%" : index === 1 ? "62%" : index === 2 ? "78%" : index === 3 ? "56%" : "48%", height: 12, borderRadius: 999 }} />
                <span className="sk-bar" style={{ width: "100%", height: 12, borderRadius: 999 }} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default function ProjectTeam () {
  useTranslation();


    //defaults.global.animation = false;
    const auth = useSelector(state=>state.auth)
    const canManageProjectMembers = auth.workspace_role === "ADMIN" || auth.workspace_role === "MANAGER";
    const dispatch = useDispatch();
    const history = useNavigate();
    const [memberModalOpen,setMemberModal] = useState(false);
    const [teamModalOpen,setTeamModal] = useState(false);
    const [editModalOpen,setEditModal] = useState(false);
    const [clientModalOpen,setClientModal] = useState(false);
    const [project_id, setProjeId] = useState(0);
    const { id: paramId } = useParams();
    const [memberList, setMemberList] = useState([]);
    const [projectName,setProjectName] = useState("");
    const [displayProjectName, setDisplayProject] = useState("");
    const [teamList,setTeamList] = useState([]);
    const [clientList,setClientList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [memberSearchTerm, setMemberSearchTerm] = useState("");
    const [time,setTime] = useState({hours:"00",minutes:"00",seconds:"00"});
    const [clientData, setClientData] = useState({ get title() { return tr("No Client"); }, id: "" });
    const [errors, setErrors] = useState({});
    const [checkArray,setCheckArray] = useState([]);
    const [project_color, setColor] = useState("");
    const [moreArray, setMoreArray] = useState([]);
    const [tagTime, setTagTime] = useState([]);
    const [tagLabel,setTagLabel] = useState([]);
    const [tagColor, setTagColor] = useState([]);
    const [memberLoading, setMemberLoading] = useState(true);
    const [manager,setManager] = useState(false);
    const [is_project_manager, setProjectManager] = useState(false);
    const hashToTab = { '#dashboard': 2, '#team': 1, '#reports': 3 };
    const tabToHash = { 2: '#dashboard', 1: '#team', 3: '#reports' };
    const initialTab = hashToTab[window.location.hash] ?? 2;
    const [tab, setTab] = useState(initialTab);
    const switchTab = (t) => { setTab(t); window.location.hash = tabToHash[t]; };
    const [sortMemberState, setSortMemberState] = useState(false)
    const [is_sole_team_viewer, setTeamViewer] = useState(false);
    const [timeDurationFormat, setTimeDurationFormat] = useState("");
    const [timeFormat, setTimeFormat] = useState("");
    const [dateFormat, setDateFormat] = useState("");
    const [defaultBillable, setDefaultBillable] = useState(false);
    const [firstDayOfWeek, setFirstday] = useState(0);
    const [reload, setReload] = useState(0);
    const [projectNotes, setProjectNotes] = useState("");
    const [activityFeed, setActivityFeed] = useState([]);
    const [projectContext, setProjectContext] = useState({
      notes: null,
      owner_name: null,
      manager_name: null,
      client_name: null,
      last_updated: null,
    });
    const [commercialSnapshot, setCommercialSnapshot] = useState({
      client_name: null,
      client_company_name: null,
      billing_readiness: { get label() { return tr("Missing"); }, tone: "missing", detail: "Billing profile incomplete" },
      billing_contact_name: null,
      billing_email: null,
      billing_profile_present: false,
      project_default_billable: false,
      linked_invoice_count: 0,
      open_invoice_total: 0,
      open_invoice_currency: "EUR",
    });
    const [projectSummary, setProjectSummary] = useState({
      total_ms: 0,
      last_7_days_ms: 0,
      active_members_last_7_days: 0,
      billable_percentage: 0,
      last_activity_timestamp: null,
    });
    const [workspaceDefaultRate, setWorkspaceDefaultRate] = useState(null);
    const [workspaceDefaultCurrencyCode, setWorkspaceDefaultCurrencyCode] = useState("");
    const [workspaceDefaultCurrencyId, setWorkspaceDefaultCurrencyId] = useState(null);
    const [currencyLookup, setCurrencyLookup] = useState([]);
    const [overrideProjectRate, setOverrideProjectRate] = useState(false);
    const [projectHourlyRate, setProjectHourlyRate] = useState("");
    const chart = useRef(null);
    const clientDropdownRef = useRef(null);
    const teamDropdownRef = useRef(null);


    const resetMemberModalState = () => {
      setMemberModal(false);
      setTeamModal(false);
      setManager(false);
      setCheckArray([]);
      setMemberSearchTerm("");
    };

    useEffect(()=>{
      const handleGlobalClick = (e) => {
        const insideMoreMenu = e.target.closest('.proj-filter-dropdown') || e.target.closest('.option-btn-show');
        if (!insideMoreMenu) setMoreArray([]);
        // Only close client dropdown when click is outside it
        if (clientDropdownRef.current && !clientDropdownRef.current.contains(e.target)) {
          setClientModal(false);
        }
        // Only close team dropdown when click is outside it
        if (teamDropdownRef.current && !teamDropdownRef.current.contains(e.target)) {
          setTeamModal(false);
        }
      };
      document.addEventListener("click", handleGlobalClick, true);
      getCurrencies();
    if(auth.user_properties !== null &&
      auth.user_properties !== undefined) {
        let timeZone = auth.user_properties.timeZone;
        if(timeZone === "" || timeZone === null || timeZone === undefined) {
          moment.tz.setDefault();
        }
        else {
          timeZone = timeZone.split(' ')[0];
          moment.tz.setDefault(timeZone)
        }
        setTimeDurationFormat(auth.user_properties.timeDurationFormat.split(' ')[0]);
        setTimeFormat(alterTimeFormat(auth.user_properties.timeFormat));
        setDateFormat(auth.user_properties.dateFormat);
        setFirstday(auth.user_properties.firstDayOfWeek);
      }
      else {
        moment.tz.setDefault();
        setTimeDurationFormat("Improved");
        setTimeFormat("hh:mm A");
        setDateFormat("DD-MM-YYYY");
        setFirstday(0);
      }

        // Support both new clean URL (/project/:id/:slug) and legacy (?id=base64)
        let project_id;
        if (paramId) {
          project_id = paramId;
        } else {
          const params = new URL(window.location.href).searchParams;
          const idstring = params.get("id");
          project_id = atob(idstring);
        }
        getWorkspaceInfo(project_id);
        setProjeId(project_id);
        getTeamList(project_id);
        getClientList();
        return () => document.removeEventListener("click", handleGlobalClick, true);
    },[])

    const resolveWorkspaceCurrencyCode = (currencyId, fallbackCode = "") => {
      if (fallbackCode) return fallbackCode;
      const match = currencyLookup.find((c) => Number(c.id) === Number(currencyId));
      return match?.currency ?? "";
    };

    useEffect(() => {
      if (!workspaceDefaultCurrencyCode && workspaceDefaultCurrencyId && currencyLookup.length > 0) {
        const match = currencyLookup.find((c) => Number(c.id) === Number(workspaceDefaultCurrencyId));
        if (match?.currency) {
          setWorkspaceDefaultCurrencyCode(match.currency);
        }
      }
    }, [currencyLookup, workspaceDefaultCurrencyId, workspaceDefaultCurrencyCode]);

    const workspaceCurrencyCode = workspaceDefaultCurrencyCode || resolveWorkspaceCurrencyCode(workspaceDefaultCurrencyId, "");

    const getCurrencies = async () => {
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${auth.token}`,
            "Content-Type": "application/json",
          },
        };
        const res = await axios.get("/api/team/currencies", config);
        if (res.status === 200) {
          setCurrencyLookup(res.data.currencies ?? []);
        }
      } catch (err) {
        console.log(err);
      }
    };

    const getWorkspaceInfo = async (project_id) => {
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${auth.token}`,
            "Content-Type": "application/json",
          },
        };
        let workspace_id = auth.workspace_id;
        const body = JSON.stringify({ workspace_id });
        let res = await axios.post(
          "/api/workspace/listbyworkspaceid",
          body,
          config
        );
        if (res.status === 200) {
          const matched = res.data.results.find(
            (item) => Number(item.id) === Number(workspace_id)
          );
          if (matched) {
            setDefaultBillable(matched.is_default_billable === 1);
            setWorkspaceDefaultRate(matched.default_billable_rate ?? null);
            setWorkspaceDefaultCurrencyId(matched.default_currency_id ?? null);
            setWorkspaceDefaultCurrencyCode(resolveWorkspaceCurrencyCode(matched.default_currency_id, matched.default_currency));
            if (matched.is_sole_team_viewer === 1) {
              const canView = auth.is_workspace_admin === 1;
              setTeamViewer(canView);
              ProjectDetails(project_id, canView);
            } else {
              setTeamViewer(true);
              ProjectDetails(project_id, true);
            }
          } else {
            // No workspace match — still load project details with default visibility
            ProjectDetails(project_id, true);
          }
        }
      } catch (err) {
        console.log(err.response);
        return err.response;
      }
    };

    const ProjectDetails = async (project_id, data) => {
  useTranslation();
        try {
          setMemberLoading(true);
          const config = {
              headers:{
                  Authorization: `Bearer ${auth.token}`,
                  "Content-Type": "application/json",
              },
          };
          let workspace_id = auth.workspace_id;
          let is_sole_teamviewer = data;
          const body = JSON.stringify({workspace_id, project_id, is_sole_teamviewer});
          let res = await axios.post("/api/project/get",body,config);
          if(res.status === 200) {
              const details  = res.data.project_details?.[0] ?? {};
              const members  = res.data.project_members  ?? [];
              const activity = res.data.activity_feed     ?? [];
              const commercial = res.data.commercial_snapshot ?? {};
              const context = res.data.project_context ?? {};
              const tagTime  = res.data.tag_time          ?? [];

              setMemberList(members);
              setDisplayProject(details.project_name  ?? "");
              setProjectName(details.project_name     ?? "");
              setProjectNotes(context.notes ?? details.notes ?? "");
              setColor(details.project_color          ?? "#1a5c30");
              setOverrideProjectRate(details.hourly_rate !== null && details.hourly_rate !== undefined);
              setProjectHourlyRate(details.hourly_rate !== null && details.hourly_rate !== undefined ? String(details.hourly_rate) : "");
              setClientData({
                title : details.client_name ?? "No Client",
                id    : details.client_id   ?? "",
              });
              setProjectContext({
                notes: context.notes ?? details.notes ?? null,
                owner_name: context.owner_name ?? null,
                manager_name: context.manager_name ?? null,
                client_name: context.client_name ?? details.client_name ?? null,
                last_updated: context.last_updated ?? details.modified_date ?? details.crdate ?? null,
              });
              setProjectManager(canManageProjectMembers);
              setProjectSummary({
                total_ms: Number(res.data.project_summary?.total_ms ?? 0),
                last_7_days_ms: Number(res.data.project_summary?.last_7_days_ms ?? 0),
                active_members_last_7_days: Number(res.data.project_summary?.active_members_last_7_days ?? 0),
                billable_percentage: Number(res.data.project_summary?.billable_percentage ?? 0),
                last_activity_timestamp: res.data.project_summary?.last_activity_timestamp ?? null,
              });
              setActivityFeed(activity);
              setCommercialSnapshot({
                client_name: commercial.client_name ?? null,
                client_company_name: commercial.client_company_name ?? null,
                billing_readiness: commercial.billing_readiness ?? { get label() { return tr("Missing"); }, tone: "missing", detail: "Billing profile incomplete" },
                billing_contact_name: commercial.billing_contact_name ?? null,
                billing_email: commercial.billing_email ?? null,
                billing_profile_present: !!commercial.billing_profile_present,
                project_default_billable: !!commercial.project_default_billable,
                linked_invoice_count: Number(commercial.linked_invoice_count ?? 0),
                open_invoice_total: Number(commercial.open_invoice_total ?? 0),
                open_invoice_currency: commercial.open_invoice_currency ?? "EUR",
              });

              // ── Tracked time ──────────────────────────────
              const rawMs = Number(res.data.project_time?.[0]?.time_by_project ?? 0);
              if (rawMs > 0) {
                let totalSec = Math.round(rawMs / 1000);
                let h = parseInt(totalSec / 3600);
                let hours = h < 10 ? "0" + h : String(h);
                totalSec  = totalSec % 3600;
                let minutes = ("0" + parseInt(totalSec / 60)).slice(-2);
                let seconds = ("0" + (totalSec % 60)).slice(-2);
                setTime({ hours, minutes, seconds });
              } else {
                setTime({ hours: "00", minutes: "00", seconds: "00" });
              }

              // ── Tag breakdown ─────────────────────────────
              // Merge duplicate untagged rows (null/empty titles) and any repeated
              // tag ids so the doughnut legend stays stable.
              const groupedTags = new Map();
              tagTime.forEach((item) => {
                const rawTitle = typeof item.tag_title === "string" ? item.tag_title.trim() : "";
                const normalizedTitle = rawTitle || "No Tag";
                const isUntagged = !item.tag_id || !rawTitle;
                const groupKey = isUntagged ? "no-tag" : `tag-${item.tag_id}`;
                const existing = groupedTags.get(groupKey);
                const nextHours = parseFloat(item.time_by_tag ?? 0) || 0;

                if (existing) {
                  existing.time += nextHours;
                  if (!existing.color && item.tagcolor) {
                    existing.color = item.tagcolor;
                  }
                } else {
                  groupedTags.set(groupKey, {
                    label: normalizedTitle,
                    time: nextHours,
                    color: item.tagcolor || "#F5FFFA",
                  });
                }
              });

              const groupedTagRows = Array.from(groupedTags.values());
              setTagLabel(groupedTagRows.map((item) => item.label));
              setTagTime(groupedTagRows.map((item) => item.time));
              setTagColor(groupedTagRows.map((item) => item.color));
          }
        } catch(err) {
          console.log(err);
          if (err.response?.status === 403) {
            dispatch(setAlert(err.response?.data?.msg || "You do not have access to this project detail", "info"));
            history("/projects");
            return;
          }
        } finally {
          setMemberLoading(false);
        }
    }

    const sortMemberList = () => {
      let array = memberList;
      let ascendingArray = array.sort(function(a, b){
        let nameA=a.name.toLowerCase(), nameB=b.name.toLowerCase();
        if (nameA < nameB) //sort string ascending
         return -1;
        if (nameA > nameB)
         return 1;
        return 0; //default return value (no sorting)
       });
       if(sortMemberState === false) {
        setSortMemberState(true);
        setMemberList([...ascendingArray]);
       }
       else {
         setSortMemberState(false)
        let descendingArray =  ascendingArray.reverse();
        setMemberList([...descendingArray]);
       }
    }

    const getClientList = async (term) => {
        try {
          const config = {
            headers: {
              Authorization: `Bearer ${auth.token}`,
              "Content-Type": "application/json",
            },
        };
          let workspace_id = auth.workspace_id;
          const searchValue = term !== undefined ? term : searchTerm;
          const body = JSON.stringify({ workspace_id, searchTerm: searchValue });
          let res = await axios.post("/api/client/search", body, config);
          if (res.status === 200) {
            setClientList(res.data.results);
          }
        } catch (err) {
          console.log(err);
          if (err.response) {
            console.log(err.response);
          }
        }
      };

    const getTeamList = async (project_id) => {
        try {
          const config = {
            headers: {
              Authorization: `Bearer ${auth.token}`,
              "Content-Type": "application/json",
            },
          };
          let workspace_id = auth.workspace_id;
          const body = JSON.stringify({ project_id, workspace_id });
          let res = await axios.post("/api/project/teamlist", body, config);
          if (res.status === 200) {
            setTeamList(res.data.results);
          }
        } catch (err) {
          if (err.response) {
            console.log(err.response);
          }
        }
      };

    const handleSearchTerm = (e) => {
        setSearchTerm(e.target.value);
    };

    const clientOnClick = (item) => {
        setClientData({title:item.client_name,id:item.id});
        setClientModal(false)
    }

    const handleProjectName = (e) => {
        setProjectName(e.target.value);
    };

    const handleProjectNotes = (e) => {
        setProjectNotes(e.target.value);
    };

    const validateForm = () => {
        let errors = {};
        let formIsValid = true;
        if (projectName === "") {
          formIsValid = false;
          errors["project_name"] = "Please enter the Project name";
        }
        if (overrideProjectRate) {
          const parsedRate = parseInt(projectHourlyRate, 10);
          if (projectHourlyRate === "" || Number.isNaN(parsedRate) || parsedRate < 0) {
            formIsValid = false;
            errors["hourly_rate"] = "Please enter a valid hourly rate";
          }
        }
        setErrors(errors);
        return formIsValid;
      };

      const selectAllTeam = () => {
        setCheckArray([]);
        let rowState = [];
        teamList.map((item, index) => {
          rowState.push(item.user_id);
          setCheckArray(rowState);
        });
      }

      const selectNone = () => {
        setCheckArray([]);
      }

    const handleCheck = (item) => {
      setCheckArray((current) => {
        if (!current.includes(item)) {
          return [...current, item];
        }
        return current.filter((selected) => selected !== item);
      });
      setTeamModal(false);
    };

    const addProjectMember = async () => {
        try {
            if (checkArray.length === 0) {
              dispatch(setAlert("Select at least one team member","danger"));
              return;
            }

            const config = {
              headers: {
                Authorization: `Bearer ${auth.token}`,
                "Content-Type": "application/json",
              },
            };
            let workspace_id = auth.workspace_id;
            let project_name = projectName;
            const body = JSON.stringify({ project_id , workspace_id,manager, checkArray, project_name });
            let res = await axios.post("/api/project_member/addmember", body, config);
            if (res.status === 200) {
                  dispatch(setAlert(res.data.msg || "Project members updated","success"));
                  if (res.data.skipped_count > 0) {
                    dispatch(setAlert(`${res.data.skipped_count} selected member${res.data.skipped_count !== 1 ? "s were" : " was"} already in the project`,"info"));
                  }
                  ProjectDetails(project_id);
                  getTeamList(project_id);
                  resetMemberModalState();
            }
          } catch (err) {
            console.log(err);
            if (err.response) {
              console.log(err.response);
              const message = err.response.data?.errors?.[0]?.msg || err.response.data?.msg || "Unable to add project member";
              dispatch(setAlert(message,"danger"));
            }
          }
    }

    const editProject = async () => {
        try {
          if (validateForm()) {
            const config = {
              headers: {
                Authorization: `Bearer ${auth.token}`,
                "Content-Type": "application/json",
              },
            };
            let workspace_id = auth.workspace_id;
            let project_name = projectName;
            let client_id;
            if (clientData.title === "No Client" && clientData.id === "") {
              client_id = "";
            } else {
              client_id = clientData.id;
            }
            let is_default_billable = 0;
            if(defaultBillable === true) {
              is_default_billable = 1;
            }
            const parsedHourlyRate = parseInt(projectHourlyRate, 10);
            const body = JSON.stringify({ project_id , is_default_billable,
                project_name, workspace_id, client_id, project_color, notes: projectNotes,
                hourly_rate: overrideProjectRate ? parsedHourlyRate : null,
                currency_id: overrideProjectRate ? workspaceDefaultCurrencyId : null });
            let res = await axios.put("/api/project/edit", body, config);
            if (res.status === 200) {
                getWorkspaceInfo(project_id);
                setReload(reload  + 1);
                setSearchTerm("");
                setEditModal(false);
            }
          }
        } catch (err) {
          console.log(err);
          if (err.response) {
            console.log(err.response);
          }
        }
      };

    const handleMoreCheck = (pm_id) => {
      setMoreArray(moreArray.includes(pm_id) ? [] : [pm_id]);
    }

    const changeRole = async (item) => {
      // Block revoking if this is the last manager
      if (item.role === 1) {
        const managerCount = memberList.filter(m => m.role === 1).length;
        if (managerCount <= 1) {
          dispatch(setAlert("Cannot revoke — project must have at least one manager", "info"));
          return;
        }
      }

      try {
          const config = {
            headers: {
              Authorization: `Bearer ${auth.token}`,
              "Content-Type": "application/json",
            },
          };
          let workspace_id = auth.workspace_id;
          let role, project_member_id;
          if(item.role === 1) {
            role = 0;
          }
          else {
            role = 1;
          }

          project_member_id = item.pm_id;

          const body = JSON.stringify({ project_member_id ,role ,workspace_id });
          let res = await axios.put("/api/project_member/edit", body, config);
          if (res.status === 200) {
              dispatch(setAlert(role === 1 ? "Manager rights granted" : "Manager rights revoked", "success"));
              ProjectDetails(project_id, is_sole_team_viewer);
              getTeamList(project_id);
          }

      } catch (err) {
        console.log(err);
        const message = err.response?.data?.msg || "Failed to update role";
        dispatch(setAlert(message, "danger"));
      }
    }

    const resendInvite = async (pm_id) => {
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${auth.token}`,
            "Content-Type": "application/json",
          },
        };
        const res = await axios.post(`/api/project_member/${pm_id}/resend`, { workspace_id: auth.workspace_id }, config);
        if (res.status === 200) {
          dispatch(setAlert("Invitation resent", "success"));
          setMoreArray([]);
        }
      } catch (err) {
        const message = err.response?.data?.msg || "Failed to resend invitation";
        dispatch(setAlert(message, "danger"));
      }
    };

    const removeMember = async (pm_id) => {
      // Block removing the last manager
      const target = memberList.find(m => m.pm_id === pm_id);
      if (target && target.role === 1) {
        const managerCount = memberList.filter(m => m.role === 1).length;
        if (managerCount <= 1) {
          dispatch(setAlert("Cannot remove — project must have at least one manager", "info"));
          return;
        }
      }

      try {
        const config = {
          headers: {
            Authorization: `Bearer ${auth.token}`,
            "Content-Type": "application/json",
          },
        };
        let workspace_id = auth.workspace_id;
        let project_member_id = pm_id;

        const body = JSON.stringify({ project_member_id ,workspace_id });
        let res = await axios.post("/api/project_member/delete", body, config);
        if (res.status === 200) {
            ProjectDetails(project_id, is_sole_team_viewer);
            getTeamList(project_id);
            dispatch(setAlert("Member removed", "success"));
        }

    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
    }

    const handleColor = (color) => {
      setColor(color);
    };

    const isDisabled = () => {
      if(teamList.length>0) {
        setMemberModal(true)
      }
      else{
       dispatch(setAlert("Added all team members to this project","info"))
      }
    }

    const data = {
      labels: tagLabel,
      datasets: [
        {
          label: 'My First dataset',
          fill: false,
          lineTension: 0.1,
          backgroundColor: tagColor,
          borderColor: "#EEF1EE",
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(75,192,192,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(75,192,192,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: tagTime
        }
      ]
    };

    const formatSummaryDuration = (ms) => {
      const totalSeconds = Math.max(0, Math.round(Number(ms || 0) / 1000));
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const hh = String(hours).padStart(2, "0");
      const mm = String(minutes).padStart(2, "0");
      const ss = String(seconds).padStart(2, "0");
      return alterDisplayTime(`${hh}:${mm}:${ss}`, timeDurationFormat || "Improved");
    };

    const formatLastActivity = (timestamp) => {
      if (!timestamp) return tr("No activity yet");
      return moment.unix(timestamp).format(`${dateFormat} • ${timeFormat}`);
    };

    const summaryCards = [
      {
        key: "total",
        get label() { return tr("Total tracked"); },
        value: formatSummaryDuration(projectSummary.total_ms),
        tone: "green",
        icon: (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        ),
      },
      {
        key: "last7",
        get label() { return tr("Last 7 days"); },
        value: formatSummaryDuration(projectSummary.last_7_days_ms),
        tone: "blue",
        icon: (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
        ),
      },
      {
        key: "members",
        get label() { return tr("Active members"); },
        value: projectSummary.active_members_last_7_days,
        meta: "In the last 7 days",
        tone: "purple",
        icon: (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        ),
      },
      {
        key: "billable",
        get label() { return tr("Billable share"); },
        value: `${projectSummary.billable_percentage}%`,
        meta: "Across tracked time",
        tone: "amber",
        icon: (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="1" x2="12" y2="23" />
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
          </svg>
        ),
      },
      {
        key: "lastActivity",
        get label() { return tr("Last activity"); },
        value: formatLastActivity(projectSummary.last_activity_timestamp),
        meta: projectSummary.last_activity_timestamp ? "Most recent timer entry" : "Waiting for first tracked entry",
        tone: "slate",
        wide: true,
        icon: (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 20V10" />
            <path d="M18 20V4" />
            <path d="M6 20v-4" />
          </svg>
        ),
      },
    ];

    const activityIcon = (type) => {
      if (type === "MEMBER_ADDED") return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <line x1="19" y1="8" x2="19" y2="14" />
          <line x1="16" y1="11" x2="22" y2="11" />
        </svg>
      );
      if (type === "MEMBER_REMOVED") return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <line x1="16" y1="11" x2="22" y2="11" />
        </svg>
      );
      if (type === "ROLE_CHANGED") return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 3l7 4v5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V7l7-4z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      );
      if (type === "PROJECT_EDITED") return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 20h9" />
          <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
        </svg>
      );
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      );
    };

    const formatActivityTime = (timestamp) => {
      if (!timestamp) return "";
      return moment(timestamp).format(`${dateFormat} • ${timeFormat}`);
    };

    const formatMoney = (amount, currency) => {
      const safeAmount = Number(amount || 0);
      try {
        return new Intl.NumberFormat(getLocale(), {
          style: "currency",
          currency: currency || "EUR",
          maximumFractionDigits: 2,
        }).format(safeAmount);
      } catch (err) {
        return `${safeAmount.toFixed(2)} ${currency || "EUR"}`;
      }
    };

    const formatContextTimestamp = (timestamp) => {
      if (!timestamp) return tr("Not updated yet");
      return moment(timestamp).format(`${dateFormat} • ${timeFormat}`);
    };

    const projectContextOwner = projectContext.manager_name || projectContext.owner_name || "Not assigned";
    const projectContextClient = projectContext.client_name || "No client linked";
    const projectContextNotes = projectContext.notes && projectContext.notes.trim()
      ? projectContext.notes.trim()
      : null;

    return(
        <div>
            <SideBar />
            <div className="header">
              <div className="container-fluid">

                {/* ── Page header: breadcrumb + edit button ── */}
                <div className="pt-header-row">
                  <div className="pt-breadcrumb">
                    <NavLink to='/projects' className="pt-breadcrumb-link">{tr("Projects")}</NavLink>
                    <span className="pt-breadcrumb-sep">›</span>
                    <span className="proj-icon" style={{backgroundColor: project_color, width: '24px', height: '24px', fontSize: '11px', borderRadius: '6px', flexShrink: 0}}>
                      {displayProjectName.charAt(0)}
                    </span>
                    <span className="pt-breadcrumb-name">{displayProjectName}</span>
                    {clientData.title && clientData.title !== 'No Client' && (
                      <span className="pt-breadcrumb-client">· {clientData.title}</span>
                    )}
                  </div>
                  {canManageProjectMembers && (
                    <button className="proj-bulk-action" data-tour="project-edit-button" onClick={() => setEditModal(true)}>{tr("Edit Project")} </button>
                  )}
                </div>

                {/* ── Tab bar ── */}
                <div className="pt-toolbar">
                  <div className="pt-kpi-panel">
                    <div className="pt-kpi-head">
                      <div>
                        <p className="pt-kpi-title">{tr("Project Snapshot")}</p>
                        <p className="pt-kpi-subtitle">{tr("Key performance signals for this project at a glance")}</p>
                      </div>
                    </div>
                    <div className="pt-kpi-strip" aria-label={tr("Project summary")}>
                      {memberLoading ? (
                        Array.from({ length: 5 }).map((_, index) => (
                          <div
                            className={`pt-kpi-card pt-kpi-card--skeleton${index === 4 ? " pt-kpi-card--wide" : ""}`}
                            key={`project-kpi-skeleton-${index}`}
                            aria-hidden="true"
                          >
                            <span className="pt-kpi-skeleton-icon sk-bar" />
                            <div className="pt-kpi-copy">
                              <span className="pt-kpi-skeleton-label sk-bar" />
                              <span className="pt-kpi-skeleton-value sk-bar" />
                              <span className="pt-kpi-skeleton-meta sk-bar" />
                            </div>
                          </div>
                        ))
                      ) : (
                        summaryCards.map((card) => (
                          <div
                            className={`pt-kpi-card pt-kpi-card--${card.tone}${card.wide ? " pt-kpi-card--wide" : ""}`}
                            key={card.key}
                          >
                            <div className={`pt-kpi-icon pt-kpi-icon--${card.tone}`}>{card.icon}</div>
                            <div className="pt-kpi-copy">
                              <span className="pt-kpi-label">{card.label}</span>
                              <span className={`pt-kpi-value${card.key === "lastActivity" ? " pt-kpi-value--compact" : ""}`}>{card.value}</span>
                              <span className="pt-kpi-meta">{card.meta || "\u00A0"}</span>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                  <div className="proj-status-tabs">
                    <button className={tab === 2 ? "proj-tab proj-tab--active" : "proj-tab"} onClick={() => switchTab(2)}>{tr("Dashboard")}</button>
                    <button className={tab === 1 ? "proj-tab proj-tab--active" : "proj-tab"} onClick={() => switchTab(1)}>Team</button>
                    <button className={tab === 3 ? "proj-tab proj-tab--active" : "proj-tab"} onClick={() => switchTab(3)}>{tr("Reports")}</button>
                  </div>
                </div>

              </div>
            </div>

            {tab === 1 ?
            <div className="content-wrap" id="wrapper">
              <div className="main">
                <div className="proj-table-wrap">

                  {/* ── Action bar ── */}
                  <div className="pt-action-bar">
                    <span className="pt-member-count">
                      {memberLoading ? (
                        <span className="pt-member-count-skeleton sk-bar" aria-hidden="true" />
                      ) : (
                        <>
                          {tr('innerMembers', { count: memberList.filter(m => m.invite_status === 'accepted' || !m.invite_status).length })}
                          {memberList.some(m => m.invite_status === 'pending') && (
                            <span style={{marginLeft:'8px', fontSize:'12px', color:'#92400e', background:'#fef3c7', border:'1px solid #fcd34d', borderRadius:'4px', padding:'1px 7px', fontWeight:600}}>
                              {memberList.filter(m => m.invite_status === 'pending').length} {tr("pending")} </span>
                          )}
                        </>
                      )}
                    </span>
                    {canManageProjectMembers && (
                      <button className="proj-bulk-action" onClick={() => isDisabled()}>{tr("+ Add Member")} </button>
                    )}
                  </div>

                  {/* ── Header row ── */}
                  <div className="proj-row proj-row--header">
                    <div className="proj-cell" style={{flex: '0 0 48px'}} />
                    <div className="proj-cell proj-cell--name">
                      <span className="proj-header-label">{tr("Member")} <span className="proj-header-sort" onClick={() => sortMemberList()}>
                          <i className="fa fa-angle-up" aria-hidden="true" />
                          <i className="fa fa-angle-down" aria-hidden="true" />
                        </span>
                      </span>
                    </div>
                    <div className="proj-cell proj-cell--client">
                      <span className="proj-header-label">{tr("Role")}</span>
                    </div>
                    {canManageProjectMembers && (
                      <div className="proj-cell proj-cell--actions" />
                    )}
                  </div>

                  {/* ── Loading state ── */}
                  {memberLoading ? (
                    Array.from({ length: 5 }).map((_, index) => (
                      <div className="proj-row proj-row--data pt-member-row-skeleton" key={`member-skeleton-${index}`} aria-hidden="true">
                        <div className="proj-cell" style={{flex: '0 0 48px'}}>
                          <span className="pt-member-skeleton-avatar sk-bar" />
                        </div>
                        <div className="proj-cell proj-cell--name">
                          <div className="cl-stack">
                            <span className="pt-member-skeleton-line pt-member-skeleton-line--name sk-bar" />
                            <span className="pt-member-skeleton-line pt-member-skeleton-line--email sk-bar" />
                          </div>
                        </div>
                        <div className="proj-cell proj-cell--client">
                          <span className="pt-member-skeleton-role sk-bar" />
                        </div>
                        {canManageProjectMembers && (
                          <div className="proj-cell proj-cell--actions">
                            <span className="pt-member-skeleton-actions sk-bar" />
                          </div>
                        )}
                      </div>
                    ))
                  ) : memberList.length === 0 ? (
                    <div className="proj-empty">
                      <div className="proj-empty-icon-wrap">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5">
                          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                          <circle cx="9" cy="7" r="4"/>
                          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                        </svg>
                      </div>
                      <div className="proj-empty-title">{tr("No members yet")}</div>
                      <div className="proj-empty-sub">{tr("Add team members to collaborate on this project.")}</div>
                      {canManageProjectMembers && (
                        <button className="proj-bulk-action" style={{marginTop: '12px'}} onClick={() => isDisabled()}>{tr("+ Add Member")} </button>
                      )}
                    </div>
                  ) : memberList.map((item, index) => (
                    <div className="proj-row proj-row--data" key={index}>

                      {/* Avatar */}
                      <div className="proj-cell" style={{flex: '0 0 48px'}}>
                        <div className="proj-team-avatar"
                          style={{backgroundColor: '#' + item.profile_name_colorcode, color: '#fff'}}>
                          {item.first_name.charAt(0)}{item.last_name.charAt(0)}
                        </div>
                      </div>

                      {/* Name + email */}
                      <div className="proj-cell proj-cell--name">
                        <div className="proj-name-primary" style={{display:'flex', alignItems:'center', gap:'8px'}}>
                          {item.name}
                          {item.invite_status === 'pending' && (
                            <span style={{fontSize:'11px', fontWeight:600, background:'#fef3c7', color:'#92400e', border:'1px solid #fcd34d', borderRadius:'4px', padding:'1px 7px'}}>{tr("Pending")} </span>
                          )}
                        </div>
                        <div className="proj-name-secondary">{item.email}</div>
                      </div>

                      {/* Role */}
                      <div className="proj-cell proj-cell--client">
                        <div className="pt-role-cell">
                          <span className="proj-badge" style={{
                            background: item.role === 1 ? '#e8f5ed' : '#f3f4f6',
                            color: item.role === 1 ? '#1a5c30' : '#6b7280',
                            border: `1px solid ${item.role === 1 ? '#a7d4b8' : '#e5e7eb'}`
                          }}>
                            {item.role === 1 ? 'Manager' : tr("Member")}
                          </span>
                          {canManageProjectMembers && (
                            <button
                              className={`pt-role-btn${item.role === 1 ? ' pt-role-btn--revoke' : ''}`}
                              onClick={() => changeRole(item)}
                              title={item.role === 1 ? tr("Revoke manager rights") : tr("Give manager rights")}
                            >
                              {item.role === 1 ? tr("Revoke") : tr("Make manager")}
                            </button>
                          )}
                        </div>
                      </div>

                      {/* More actions */}
                      {canManageProjectMembers && (
                        <div className="proj-cell proj-cell--actions">
                          <div style={{position: 'relative'}} onClick={() => handleMoreCheck(item.pm_id)}>
                            <div tabIndex="0" title={tr("More actions")} className="option-btn-show">
                              <svg width="4" height="16" viewBox="0 0 4 16">
                                <path fill="#cecece" fillRule="evenodd" d="M0 2a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm0 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm0-6a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"/>
                              </svg>
                            </div>
                            {moreArray.includes(item.pm_id) && (
                              <div className="proj-filter-dropdown" style={{right: 0, left: 'auto', minWidth: '190px', zIndex: 300}}>
                                {item.invite_status === 'pending' && (
                                  <div
                                    className="proj-filter-dd-item"
                                    onClick={(e) => { e.stopPropagation(); resendInvite(item.pm_id); }}
                                  >
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '8px', flexShrink: 0}}>
                                      <polyline points="22 2 15 22 11 12 2 9 22 2"/><line x1="22" y1="2" x2="11" y2="12"/>
                                    </svg>{tr("Resend invite")} </div>
                                )}
                                <div
                                  className="proj-filter-dd-item proj-filter-dd-item--danger"
                                  onClick={(e) => { e.stopPropagation(); setMoreArray([]); removeMember(item.pm_id); }}
                                >
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '8px', flexShrink: 0}}>
                                    <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
                                  </svg>{tr("Remove")} </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                    </div>
                  ))}
                </div>

                {/* ── Project Overview card ── */}
                <div className="proj-chart-card">
                  <div className="proj-chart-header">
                    <div>
                      <p className="proj-chart-title">{tr("Project Overview")}</p>
                      <p className="proj-chart-sub">
                        {clientData.title && clientData.title !== 'No Client'
                          ? `Client: ${clientData.title}`
                          : tr("No client assigned")}
                      </p>
                    </div>
                    <div style={{textAlign: 'right'}}>
                      <p className="proj-chart-title" style={{fontVariantNumeric: 'tabular-nums', fontFamily: "'Courier New', monospace"}}>
                        {time.hours}:{time.minutes}:{time.seconds}
                      </p>
                      <p className="proj-chart-sub">{tr("Total tracked time")}</p>
                    </div>
                  </div>
                  {canManageProjectMembers && tagTime.length > 0 && (
                    <div className="proj-chart-body">
                      <div className="proj-donut-wrap">
                        <Doughnut key={getLocale()}
                          ref={chart}
                          data={data}
                          width={180}
                          options={{legend: false, title: {display: false}}}
                        />
                      </div>
                      <div className="proj-list">
                        {tagLabel.map((label, i) => (
                          <div className="proj-list-item proj-list-item--in" key={i}>
                            <div className="proj-list-top">
                              <div className="proj-list-dot" style={{backgroundColor: tagColor[i] || '#ccc'}} />
                              <span className="proj-list-name">{label || tr("No Tag")}</span>
                              <span className="proj-list-time">{parseFloat(tagTime[i] || 0).toFixed(2)}{tr("h")}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div className="proj-chart-card">
                  <div className="proj-chart-header">
                    <div>
                      <p className="proj-chart-title">{tr("Project Context")}</p>
                      <p className="proj-chart-sub">{tr("Quick ownership, client, and summary context for onboarding and handoff")}</p>
                    </div>
                  </div>

                  <div className="pt-context-body">
                    <div className="pt-context-summary">
                      <span className="pt-context-label">{tr("Project Summary")}</span>
                      {projectContextNotes ? (
                        <p className="pt-context-notes">{projectContextNotes}</p>
                      ) : (
                        <div className="pt-context-empty">{tr("No project summary has been added yet. Add a short overview so teammates can understand the purpose and ownership quickly.")} </div>
                      )}
                    </div>

                    <div className="pt-context-grid">
                      <div className="pt-context-stat pt-context-stat--primary">
                        <span className="pt-context-label">{tr("Owner / Manager")}</span>
                        <span className="pt-context-value">{projectContextOwner}</span>
                        <span className="pt-context-meta">
                          {projectContext.manager_name ? tr("Current project manager") : projectContext.owner_name ? tr("Project owner") : tr("Assign a manager for clearer ownership")}
                        </span>
                      </div>

                      <div className="pt-context-stat">
                        <span className="pt-context-label">{tr("Client")}</span>
                        <span className="pt-context-value">{projectContextClient}</span>
                        <span className="pt-context-meta">
                          {projectContext.client_name ? tr("Linked client on this project") : tr("No client linked yet")}
                        </span>
                      </div>

                      <div className="pt-context-stat">
                        <span className="pt-context-label">{tr("Last Updated")}</span>
                        <span className="pt-context-value">{formatContextTimestamp(projectContext.last_updated)}</span>
                        <span className="pt-context-meta">{tr("Based on the latest saved project metadata")} </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="proj-chart-card">
                  <div className="proj-chart-header">
                    <div>
                      <p className="proj-chart-title">{tr("Commercial Snapshot")}</p>
                      <p className="proj-chart-sub">{tr("Client, billing, and invoice context for this project")}</p>
                    </div>
                  </div>

                  <div className="pt-commercial-body">
                    <div className="pt-commercial-grid">
                      <div className="pt-commercial-stat pt-commercial-stat--primary">
                        <span className="pt-commercial-label">{tr("Client")}</span>
                        <span className="pt-commercial-value">
                          {commercialSnapshot.client_name || tr("No client linked")}
                        </span>
                        <span className="pt-commercial-meta">
                          {commercialSnapshot.client_company_name || (commercialSnapshot.client_name ? tr("Company name missing") : tr("Link a client to unlock billing context"))}
                        </span>
                      </div>

                      <div className="pt-commercial-stat">
                        <span className="pt-commercial-label">{tr("Billing Readiness")}</span>
                        <span className={`pt-commercial-badge pt-commercial-badge--${commercialSnapshot.billing_readiness?.tone || "missing"}`}>
                          {commercialSnapshot.billing_readiness?.label || tr("Missing")}
                        </span>
                        <span className="pt-commercial-meta">
                          {commercialSnapshot.billing_readiness?.detail || tr("Billing profile incomplete")}
                        </span>
                      </div>

                      <div className="pt-commercial-stat">
                        <span className="pt-commercial-label">{tr("Default Billable")}</span>
                        <span className="pt-commercial-value">
                          {commercialSnapshot.project_default_billable ? tr("Billable") : tr("Non-billable")}
                        </span>
                        <span className="pt-commercial-meta">
                          {commercialSnapshot.project_default_billable
                            ? tr("New time defaults to billable for this project")
                            : tr("New time defaults to non-billable")}
                        </span>
                      </div>

                      <div className="pt-commercial-stat">
                        <span className="pt-commercial-label">{tr("Linked Invoices")}</span>
                        <span className="pt-commercial-value">{commercialSnapshot.linked_invoice_count}</span>
                        <span className="pt-commercial-meta">
                          {commercialSnapshot.linked_invoice_count > 0 ? tr("Invoices linked through project line items") : tr("No linked invoices yet")}
                        </span>
                      </div>

                      <div className="pt-commercial-stat">
                        <span className="pt-commercial-label">{tr("Open Invoice Total")}</span>
                        <span className="pt-commercial-value">
                          {commercialSnapshot.linked_invoice_count > 0
                            ? formatMoney(commercialSnapshot.open_invoice_total, commercialSnapshot.open_invoice_currency)
                            : "—"}
                        </span>
                        <span className="pt-commercial-meta">
                          {commercialSnapshot.linked_invoice_count > 0
                            ? tr("Unpaid issued / overdue balance for linked invoices")
                            : tr("Available once invoices are linked to this project")}
                        </span>
                      </div>
                    </div>

                    {!commercialSnapshot.billing_profile_present && (
                      <div className="pt-commercial-empty">{tr("No billing profile is saved for this client yet.")} </div>
                    )}
                  </div>
                </div>

                <div className="proj-chart-card">
                  <div className="proj-chart-header">
                    <div>
                      <p className="proj-chart-title">{tr("Recent Activity")}</p>
                      <p className="proj-chart-sub">{tr("Latest operational events across project changes and tracked time")}</p>
                    </div>
                  </div>

                  <div className="pt-activity-body">
                    {memberLoading ? (
                      Array.from({ length: 5 }).map((_, index) => (
                        <div className="pt-activity-item pt-activity-item--skeleton" key={`activity-skeleton-${index}`} aria-hidden="true">
                          <span className="pt-activity-skeleton-icon sk-bar" />
                          <div className="pt-activity-content">
                            <span className="pt-activity-skeleton-title sk-bar" />
                            <span className="pt-activity-skeleton-text sk-bar" />
                            <span className="pt-activity-skeleton-meta sk-bar" />
                          </div>
                        </div>
                      ))
                    ) : activityFeed.length === 0 ? (
                      <div className="proj-empty" style={{padding: '36px 0'}}>
                        <div className="proj-empty-title" style={{fontSize: '14px'}}>{tr("No recent activity")}</div>
                        <div className="proj-empty-sub">{tr("Project updates and recent time entries will appear here.")}</div>
                      </div>
                    ) : (
                      activityFeed.map((item) => (
                        <div className="pt-activity-item" key={item.id}>
                          <div className={`pt-activity-icon${item.type === 'TIME_ENTRY' ? ' pt-activity-icon--time' : ''}`}>
                            {activityIcon(item.type)}
                          </div>
                          <div className="pt-activity-content">
                            <div className="pt-activity-top">
                              <span className="pt-activity-label">{item.label}</span>
                              <span className="pt-activity-time">{formatActivityTime(item.timestamp)}</span>
                            </div>
                            <div className="pt-activity-desc">{item.description}</div>
                            <div className="pt-activity-meta">
                              {item.actor_name ? `By ${item.actor_name}` : tr("System event")}
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>

              </div>
            </div>
            : tab === 2 ?
            <Suspense fallback={<ProjectDashboardSkeleton />}>
            <Dashboard
              project_id={project_id}
              is_sole_team_viewer={is_sole_team_viewer === false ? (is_project_manager ? true : false) : true}
              memberList={memberList}
              tagLabel={tagLabel}
              tagTime={tagTime}
              tagColor={tagColor}
              projectSummary={projectSummary}
            />
            </Suspense>
            :
            <Suspense fallback={<Loader />}>
              <ProjectReport
                project_id={project_id}
                manager={is_project_manager}
                is_sole_team_viewer={is_sole_team_viewer === false ? (is_project_manager ? true : false) : true}
                reload={reload}
              />
            </Suspense>
            }

            {/* ── Edit Project Modal ── */}
            {canManageProjectMembers && (
            <Modal
              show={editModalOpen}
              onHide={() => setEditModal(false)}
              dialogClassName='add-New-tag-popup-box-container add-New-tag-popup-box-container--edit'
              bsPrefix=''
            >
              <div className="pm-header">
                <h3 className="pm-title">{tr("Edit Project")}</h3>
                <button className="pm-close" onClick={() => setEditModal(false)}>&#x2715;</button>
              </div>
              <div className="pm-body">
                <div className="pm-field">
                  <label className="pm-label">Name</label>
                  <input
                    className="pm-input"
                    type="text"
                    placeholder={tr("Project name...")}
                    value={projectName}
                    onChange={handleProjectName}
                  />
                  {errors.project_name && <span className="pm-error">{errors.project_name}</span>}
                </div>

                <div className="pm-field" style={{position: 'relative'}} ref={clientDropdownRef}>
                  <label className="pm-label">{tr("Client")}</label>
                  <div className="pm-select" onClick={() => setClientModal(!clientModalOpen)}>
                    <span className="pm-select-value">{clientData.id === 0 || clientData.id === '' ? tr("No Client") : clientData.title}</span>
                    <i className={`fa fa-angle-${clientModalOpen ? 'up' : 'down'} pm-select-icon`} />
                  </div>
                  {clientModalOpen && (
                    <div className="pm-dropdown">
                      <div className="pm-dropdown-search">
                        <input
                          className="pm-dropdown-search-input"
                          type="text"
                          placeholder={tr("Find client...")}
                          onChange={(e) => { setSearchTerm(e.target.value); getClientList(e.target.value); }}
                          value={searchTerm}
                        />
                      </div>
                      <ul className="pm-dropdown-list">
                        <li className="pm-dropdown-item" onClick={() => clientOnClick({client_name: 'No Client', id: ''})}>{tr("No client")}</li>
                        {clientList.map((item, index) => (
                          <li
                            className={`pm-dropdown-item${clientData.id === item.id ? ' pm-dropdown-item--active' : ''}`}
                            key={index}
                            onClick={() => clientOnClick(item)}
                          >
                            {item.client_name}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

                <div className="pm-field">
                  <label className="pm-label">{tr("Color")}</label>
                  <ColorPicker onSelectColor={(color) => handleColor(color)} dbColor={project_color}/>
                </div>

                <ProjectBillingRateField
                  enabled={overrideProjectRate}
                  onToggle={() => {
                    setOverrideProjectRate((current) => {
                      const next = !current;
                      if (next && !projectHourlyRate) {
                        setProjectHourlyRate(String(workspaceDefaultRate ?? ""));
                      }
                      return next;
                    });
                  }}
                  rate={projectHourlyRate}
                  onRateChange={(value) => setProjectHourlyRate(value)}
                  currencyLabel={workspaceCurrencyCode}
                  workspaceRateLabel={workspaceDefaultRate !== null && workspaceDefaultRate !== undefined
                    ? `${workspaceCurrencyCode ? `${workspaceCurrencyCode} ` : ""}${workspaceDefaultRate}/hr`
                    : ""}
                  error={errors.hourly_rate}
                  warning="This override applies to future entries only. Existing tracked time is not rewritten."
                  note={tr("Currency is taken from Workspace Settings > Rates & Currency.")}
                />

                <div className="pm-field">
                  <label className="pm-label">{tr("Project Summary")}</label>
                  <textarea
                    className="pm-input pt-project-notes-input"
                    placeholder={tr("Add a short summary of the project, goals, owners, or delivery context...")}
                    value={projectNotes}
                    onChange={handleProjectNotes}
                    rows={5}
                  />
                </div>
              </div>
              <div className="pm-footer">
                <button className="pm-btn-cancel" onClick={() => setEditModal(false)}>{tr("Cancel")}</button>
                <button className="pm-btn-create" data-tour="project-save-button" onClick={() => editProject()}>{tr("Save Changes")}</button>
              </div>
            </Modal>
            )}

            {/* ── Add Member Modal ── */}
            {canManageProjectMembers && (
            <Modal
              show={memberModalOpen}
              onHide={resetMemberModalState}
              dialogClassName='add-New-tag-popup-box-container'
              bsPrefix=''
              backdrop="static"
            >
              <div className="pm-header">
                <h3 className="pm-title">{tr("Add Project Members")}</h3>
                <button className="pm-close" onClick={resetMemberModalState}>&#x2715;</button>
              </div>
              <div className="pm-body">
                <div className="pm-field" style={{position: 'relative'}} ref={teamDropdownRef}>
                  <label className="pm-label">{tr("Select Team Member or Group")}</label>
                  <div className="pm-select" onClick={() => setTeamModal((current) => !current)}>
                    <span className="pm-select-value">
                      {checkArray.length > 0 ? tr('innerMembersSelected', { count: checkArray.length }) : tr("Select member...")}
                    </span>
                    <i className={`fa fa-angle-${teamModalOpen ? 'up' : 'down'} pm-select-icon`} />
                  </div>
                  {teamModalOpen && (
                    <div className="pm-dropdown">
                      <div className="pm-dropdown-search">
                        <input
                          className="pm-dropdown-search-input"
                          type="text"
                          placeholder={tr("Find members...")}
                          value={memberSearchTerm}
                          onChange={(e) => setMemberSearchTerm(e.target.value)}
                        />
                      </div>
                      <div style={{padding: '6px 12px 4px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <span style={{fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#9ca3af'}}>{tr("Invited Members")}</span>
                        <span style={{display: 'flex', gap: '10px'}}>
                          <a href='javascript:void(0)' onClick={() => selectAllTeam()} style={{fontSize: '12px', color: '#1a5c30', fontWeight: 500}}>{tr("All")}</a>
                          <a href='javascript:void(0)' onClick={() => selectNone()} style={{fontSize: '12px', color: '#1a5c30', fontWeight: 500}}>{tr("None")}</a>
                        </span>
                      </div>
                      <ul className="pm-dropdown-list">
                        {teamList.filter(item => {
                          if (!memberSearchTerm.trim()) return true;
                          const term = memberSearchTerm.toLowerCase();
                          return (
                            (item.first_name || '').toLowerCase().includes(term) ||
                            (item.last_name  || '').toLowerCase().includes(term) ||
                            (item.email      || '').toLowerCase().includes(term)
                          );
                        }).map((item, index) => (
                          <li
                            className={`pm-dropdown-item${checkArray.includes(item.user_id) ? ' pm-dropdown-item--active' : ''}`}
                            key={index}
                            onClick={() => handleCheck(item.user_id)}
                          >
                            <span style={{display: 'inline-flex', alignItems: 'center', gap: '8px'}}>
                              <span style={{
                                width: '24px', height: '24px', borderRadius: '50%',
                                background: '#' + (item.profile_name_colorcode || 'aaaaaa'),
                                color: '#fff', fontSize: '10px', fontWeight: 700,
                                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                flexShrink: 0
                              }}>
                                {item.first_name.charAt(0)}{item.last_name.charAt(0)}
                              </span>
                              {item.first_name} {item.last_name}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

                <div className="pm-field">
                  <label className="pm-label">{tr("Project Role")}</label>
                  <div className="pm-role-toggle" role="radiogroup" aria-label={tr("Project role")}>
                    <button
                      type="button"
                      className={`pm-role-toggle__option${!manager ? ' pm-role-toggle__option--active' : ''}`}
                      onClick={() => setManager(false)}
                      aria-pressed={!manager}
                    >
                      <span className="pm-role-toggle__title">{tr("Member")}</span>
                      <span className="pm-role-toggle__meta">{tr("Can track time and join the project")}</span>
                    </button>
                    <button
                      type="button"
                      className={`pm-role-toggle__option${manager ? ' pm-role-toggle__option--active' : ''}`}
                      onClick={() => setManager(true)}
                      aria-pressed={manager}
                    >
                      <span className="pm-role-toggle__title">Manager</span>
                      <span className="pm-role-toggle__meta">{tr("Can manage project members and roles")}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="pm-footer">
                <button className="pm-btn-cancel" onClick={resetMemberModalState}>{tr("Cancel")}</button>
                <button className="pm-btn-create" onClick={() => addProjectMember()}>{tr("Add Members")}</button>
              </div>
            </Modal>
            )}

        </div>
    )
}
